<template>
    <div>
        <div class="pagetitle">
            <h1>Pelamar</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Forms</li>
                    <li class="breadcrumb-item active">Pelamar</li>
                </ol>
            </nav>
        </div>
        <div class="col text-left">
            <a href="#" class="btn btn-sm btn-primary shadow-sm" data-toggle="modal" data-target="#tambahApplicant">
                <i class="bi bi-plus fa-sm text-white-50"></i> Tambah Pelamar
            </a>
        </div><br>
        <div class="row mb-3">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Pelamar</h5>
                        <div>
                            <label for="searchQuery" class="form-label">Search:</label>
                            <input type="text" v-model="searchQuery" class="form-control" @change="fetchApplicants" placeholder="Search by Nama ....... ">
                            <div class="form-group mb-3 d-inline-block mr-3">
                                <label for="pageSize" class="form-label">Items per page:</label>
                                <select name="pageSize" id="pageSize" v-model="pageSize" @change="fetchApplicants" class="form-select">
                                    <option v-for="size in [1, 5, 10, 15, 20, 100]" :key="size" :value="size">
                                        {{ size }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group mb-3 d-inline-block mr-3">
                                <label for="periode" class="form-label">Periode:</label>
                                <select name="periode" id="periode" v-model="periode" @click="fetchApplicants" class="form-select"> <!--@change="fetchApplicants" -->
                                    <option value="all">Semua</option>
                                    <option value="1 week">1 Minggu</option>
                                    <option value="1 month">1 Bulan</option>
                                    <option value="1 year">1 Tahun</option>
                                </select>
                            </div>
                            <div class="form-group mb-3 d-inline-block">
                                <a href="#" class="btn btn-sm btn-success shadow-sm" @click="downloadApplicantList">
                                    <i class="bi bi-download fa-sm text-white-50"></i> Download Data
                                </a>
                            </div>
                            <table class="table table-striped table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">No</th>
                                        <th scope="col">Nama</th>
                                        <th scope="col">Posisi</th>
                                        <th scope="col">Informasi Pribadi</th>
                                        <th scope="col">Berkas</th>
                                        <!-- <th scope="col">Status</th> -->
                                        <th scope="col" style="text-align: center;">Opsi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(applicant, index) in filteredApplicants" :key="index">
                                        <th scope="row">{{ index + 1 + (currentPage - 1) * pageSize }}</th>
                                        <td>{{ applicant.name_aplicant }}</td>
                                        <td>{{ applicant.positions }}</td>
                                        <td>
                                            Email : {{ applicant.email }}
                                            <br>
                                            No Telepon : {{ applicant.no_hp }}
                                        </td>
                                        <td>
                                            <a :href="gambarUrl + applicant.cv" target="_blank" class="btn btn-sm btn-outline-success shadow-sm">
                                                <i class="bi bi-eye fa-sm text-dark"></i>
                                            </a>
                                        </td>
                                        <!-- <td>
                                            <span v-if="applicant.status == '0'" class="badge bg-secondary">Belum diverifikasi</span>
                                            <span v-else-if="applicant.status == '1'" class="badge bg-info">Tahap Test Wawancara</span>
                                            <span v-else-if="applicant.status == '2'" class="badge bg-primary">Tahap test Kemampuan</span>
                                            <span v-else-if="applicant.status == '5'" class="badge bg-warning">Tahap Test Psikotes</span>
                                            <span v-else-if="applicant.status == '3'" class="badge bg-success">Diterima</span>
                                            <span v-else-if="applicant.status == '4'" class="badge bg-danger">Ditolak</span>
                                            <span v-else class="badge bg-dark">Baru Apply</span>
                                        </td> -->
                                        <td style="text-align: center;">
                                            <a href="#" class="btn btn-sm btn-outline-primary shadow-sm"  style="margin-right: 5px" @click="showModal('detail',applicant.id)">
                                                <i class="bi bi-info-circle fa-sm text-dark"></i>
                                            </a>
                                            <!-- <a href="#" class="btn btn-sm btn-outline-warning shadow-sm" style="margin-right: 5px" @click="showModal('edit',applicant.id)">
                                                <i class="bi bi-pencil-square fa-sm text-dark"></i>
                                            </a> -->
                                            <a href="#" class="btn btn-sm btn-outline-danger shadow-sm" style="margin-right: 5px" @click="deleteApplicant(applicant.id, applicant.cv)">
                                                <i class="bi bi-trash fa-sm text-dark"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul class="pagination justify-content-center" @change="fetchApplicants">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                                    </li>
                                    <li v-if="showStartEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li
                                        class="page-item"
                                        v-for="page in displayedPages"
                                        :key="page"
                                        :class="{ active: currentPage === page }"
                                    >
                                        <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                    </li>
                                    <li v-if="showEndEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === pages }">
                                        <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === pages">Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="tambahApplicant" tabindex="-1" role="dialog" aria-labelledby="tambahApplicant" >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tambahSuratModalLabel">Applicant Forms</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="addApplicant" enctype="multipart/form-data" :headers="{ 'Content-Type': 'multipart/form-data' }">
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="floatingName" placeholder="Nama Pelamar" v-model="applicant.name_aplicant">
                                    <label for="floatingName">Nama Pelamar</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <select 
                                        name="id_career" 
                                        id="id_career" 
                                        class="form-select" 
                                        v-model="applicant.id_career">
                                        <option v-for="(position) in careerList" :key="position.id" :value="position.id">
                                            {{ position.positions }}
                                        </option>
                                    </select>
                                    <label for="id_career">Career</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="phone" placeholder="phone" v-model="applicant.no_hp">
                                    <label for="phone">No. Telepon</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="email" class="form-control" id="email" placeholder="email" v-model="applicant.email">
                                    <label for="email">Email</label>
                                </div>
                            </div>
                            <div class="form-group col-md-12 mb-3">
                                <label for="gambar">CV</label>
                                <div class="input-group">
                                    <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="gambar" @change="handleFileUpload" accept=".pdf">
                                        <label class="custom-file-label" for="gambar">{{ fileName }}</label>
                                    </div>
                                </div>
                                <div v-if="fileUrl" class="mt-3 text-center">
                                    <iframe :src="fileUrl" style="width: 100%; height: 500px;"></iframe>
                                </div>
                            </div>
                            <!-- <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="status" id="status" v-model="applicant.status">
                                        <option value="0">Belum diverifikasi</option>
                                        <option value="1">Tahap Wawancara</option>
                                        <option value="2">Tahap tes Kemampuan</option>
                                        <option value="5">Tahap tes Psikotes</option>
                                        <option value="3">Diterima</option>
                                        <option value="4">Ditolak</option>
                                    </select>
                                    <label for="status">Status</label>
                                </div>
                            </div> -->
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Submit</button> ||
                                <button type="button" class="btn btn-secondary" @click="resetForm">Reset</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div ref="detailApplicantModal" class="modal fade" id="detailApplicant" tabindex="-1" role="dialog" aria-labelledby="detailApplicant">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="detailApplicantModalLabel">Detail Applicant</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="nama_Applicant">Nama Pelamar</label>
                                        <input type="text" class="form-control" id="nama_pelamar" placeholder="Nama Pelamar" v-model="applicant.name_aplicant" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="position">Posisi yang dilamar</label>
                                        <input type="text" class="form-control" id="posisi" placeholder="Posisi" v-model="applicant.positions" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="email">Email</label>
                                        <input type="text" class="form-control" id="email" placeholder="Email" v-model="applicant.email" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="no_hp">No. HP</label>
                                        <input type="text" class="form-control" id="no_hp" placeholder="No. HP" v-model="applicant.no_hp" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="verkas">Berkas</label> <br>
                                        <a :href="`${gambarUrl}${applicant.cv}`" target="_blank" class="btn btn-sm btn-outline-success shadow-sm">
                                            <i class="bi bi-eye fa-sm text-dark"></i>
                                        </a>
                                    </div>
                                </div>
                                <!-- <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="status">Status</label>
                                        <select class="form-control" name="status" id="status" v-model="applicant.status" disabled>
                                            <option value="null">Belum diverifikasi</option>
                                            <option value="1">Tahap Wawancara</option>
                                            <option value="2">Tahap tes Kemampuan</option>
                                            <option value="3">Diterima</option>
                                            <option value="4">Ditolak</option>
                                            <option value="5">Tahap tes Psikotes</option>
                                        </select>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div class="text-center">
                            <button class="btn btn-secondary" @click="closeModal"> Close </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="editApplicant" tabindex="-1" role="dialog" aria-labelledby="editApplicant" >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="editApplicantModalLabel">Edit Status Lamaran</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="updateApplicant">
                            <input type="hidden" class="form-control" id="ID" placeholder="ID" v-model="selectedApplicant.updated_by" readonly>
                            <input type="hidden" class="form-control" id="Nama" placeholder="Nama" v-model="selectedApplicant.updated_by_name" readonly>
                            <input type="hidden" class="form-control" id="id" placeholder="ID" v-model="applicant.id" readonly>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="nama_Applicant">Nama Pelamar</label>
                                    <input type="text" class="form-control" id="nama_pelamar" placeholder="Nama Pelamar" v-model="applicant.name_aplicant" readonly>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="position">Posisi yang dilamar</label>
                                    <input type="text" class="form-control" id="posisi" placeholder="Posisi" v-model="applicant.positions" readonly>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="email">Email</label>
                                    <input type="text" class="form-control" id="email" placeholder="Email" v-model="applicant.email" readonly>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="no_hp">No. HP</label>
                                    <input type="text" class="form-control" id="no_hp" placeholder="No. HP" v-model="applicant.no_hp" readonly>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="berkas">Berkas</label> <br>
                                    <a :href="`${gambarUrl}${applicant.cv}`" target="_blank" class="btn btn-sm btn-outline-success shadow-sm">
                                        <i class="bi bi-eye fa-sm text-dark"></i>
                                    </a>
                                </div>
                            </div>
                            <!-- <div class="col-md-12">
                                <div class="form-group">
                                    <label for="status">Status</label>
                                    <select class="form-control" name="status" id="status" v-model="applicant.status" @change="handleStatusChange">
                                        <option value="">Belum diverifikasi</option>
                                        <option value="1">Tahap Wawancara</option>
                                        <option value="2">Tahap tes Kemampuan</option>
                                        <option value="5">Tahap tes Psikotes</option>
                                        <option value="3">Diterima</option>
                                        <option value="4">Ditolak</option>
                                    </select>
                                </div>
                            </div>
                            <div v-if="applicant.status === '3' || applicant.status === '1' || applicant.status === '2'" class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <input type="date" class="form-control" id="tanggal" placeholder="Tanggal" v-model="selectedApplicant.tanggal">
                                    <label for="tanggal">Tanggal</label>
                                </div>
                            </div>
                            <div v-if="applicant.status === '5'" class="col-md-12 mb-3">
                                <div class="form-float">
                                    <label for="link">Link</label>
                                    <input type="text" class="form-control" id="link" placeholder="Link" v-model="selectedApplicant.link">
                                </div>
                            </div> -->
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import applicantjs from './jsApplicant/applicant';
export default applicantjs;
</script>